import PropTypes from "prop-types";
import {
  APP_BRAND_TITLE,
  APP_LOGO_ALT,
  APP_LOGO_URL,
} from "../../Constants/branding";

const VARIANTS = {
  auth: {
    wrap: "flex flex-col items-center justify-center gap-2 w-full",
    image: "h-16 w-auto max-w-[120px] object-contain",
    text: "text-[18px] sm:text-[20px] font-semibold text-main tracking-tight",
  },
  sidebar: {
    wrap: "flex items-center gap-2 min-w-0",
    image: "h-8 w-8 shrink-0 object-contain",
    text: "text-[12px] font-semibold text-main leading-tight truncate",
  },
  "sidebar-collapsed": {
    wrap: "flex items-center justify-center",
    image: "h-8 w-8 object-contain",
    text: "",
  },
};

function BrandTitle({ className }) {
  return (
    <p className={className}>
      BMC <span className="text-dark-secondary font-medium">|</span> Waterlogging
    </p>
  );
}

const AppBrandMark = ({ variant = "auth", className = "" }) => {
  const styles = VARIANTS[variant] ?? VARIANTS.auth;
  const showText = variant !== "sidebar-collapsed";

  return (
    <div className={`${styles.wrap} ${className}`.trim()}>
      <img src={APP_LOGO_URL} alt={APP_LOGO_ALT} className={styles.image} />
      {showText ? <BrandTitle className={styles.text} /> : null}
    </div>
  );
};

AppBrandMark.propTypes = {
  variant: PropTypes.oneOf(["auth", "sidebar", "sidebar-collapsed"]),
  className: PropTypes.string,
};

export default AppBrandMark;
export { BrandTitle };
